
export enum Resident_State {
    Alabama = "Alabama",
    Alaska = "Alaska",
    Arizona = "Arizona",
    Arkansas = "Arkansas",
    California = "California",
    Colorado = "Colorado",
    Connecticut = "Connecticut",
    Delaware = "Delaware",
    Florida = "Florida",
    Georgia = "Georgia",
    Hawaii = "Hawaii",
    Idaho = "Idaho",
    Illinois = "Illinois",
    Indiana = "Indiana",
    Iowa = "Iowa",
    Kansas = "Kansas",
    Kentucky = "Kentucky",
    Louisiana = "Louisiana",
    Maine = "Maine",
    Maryland = "Maryland",
    Massachusetts = "Massachusetts",
    Michigan = "Michigan",
    Minnesota = "Minnesota",
    Mississippi = "Mississippi",
    Missouri = "Missouri",
    Montana = "Montana",
    Nebraska = "Nebraska",
    Nevada = "Nevada",
    New_Hampshire = "New Hampshire",
    New_Jersey = "New Jersey",
    New_Mexico = "New Mexico",
    New_York = "New York",
    North_Carolina = "North Carolina",
    North_Dakota = "North Dakota",
    Ohio = "Ohio",
    Oklahoma = "Oklahoma",
    Oregon = "Oregon",
    Oversea = "Oversea",
    Pennsylvania = "Pennsylvania",
    Rhode_Island = "Rhode Island",
    South_Carolina = "South Carolina",
    South_Dakota = "South Dakota",
    Tennessee = "Tennessee",
    Texas = "Texas",
    Utah = "Utah",
    Vermont = "Vermont",
    Virginia = "Virginia",
    Washington = "Washington",
    West_Virginia = "West Virginia",
    Wisconsin = "Wisconsin",
    Wyoming = "Wyoming",
  }
  